// 📣 POG sounds — tiny WebAudio cues, no assets needed.
export const whistleBlast = () => {
  try {
    if (navigator.vibrate) navigator.vibrate([80, 40, 120]);
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const blow = (freq, start, dur) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.setValueAtTime(freq, ctx.currentTime + start);
      o.frequency.linearRampToValueAtTime(freq * 1.18, ctx.currentTime + start + dur * 0.6);
      g.gain.setValueAtTime(0.0001, ctx.currentTime + start);
      g.gain.exponentialRampToValueAtTime(0.18, ctx.currentTime + start + 0.03);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + start + dur);
      o.connect(g).connect(ctx.destination);
      o.start(ctx.currentTime + start);
      o.stop(ctx.currentTime + start + dur + 0.05);
    };
    blow(1800, 0, 0.28);
    blow(2100, 0.34, 0.42);
    setTimeout(() => ctx.close().catch(() => {}), 1400);
  } catch (e) { /* autoplay blocked — the pill still shows */ }
};
